import { AddTimeEntry } from 'components/organisms/task-pane/task-detail/header/add-time-entry';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacAddTimeEntry = withAccess(AddTimeEntry);
